import General from '../pages/Ledgers/General';
import General2 from '../pages/Ledgers/General2';

const generalLedgerRoute = {
  public: [],
  auth: [
    {
      name: 'general_ledger',
      path: '/finance-and-accounting/general-ledger',
      component: General,
    },
    {
      name: 'general_ledger_2',
      path: '/finance-and-accounting/general-ledger-2',
      component: General2,
    },
  ],
};

export default generalLedgerRoute;
